export enum OrgTypeStoreModelEnum {
  System = 'SYSTEM',
  Operator = 'OPERATOR',
}

export enum FeatureFlags {
  Roaming = 'ROAMING',
  Sharing = 'SHARING',
  Flexibility = 'FLEXIBILITY',
  AiAssistant = 'AI_ASSISTANT',
  PredictiveAnalytics = 'PREDICTIVE_ANALYTICS',
  DisplayTimezones = 'DISPLAY_TIMEZONES',
}
